import React from "react";
import {Table} from "react-bootstrap";

function STCTable(props){

    return(
        <Table
            style={props.style}
            className={props.className}

            bordered={props.bordered}
            borderless={props.borderless}
            hover={props.hover}
            responsive={props.responsive}
            size={props.size}
            striped={props.striped}
            variant={props.variant}
            bsPrefix={props.bsPrefix}

        >
            {props.children}
        </Table>
    )
}
export default STCTable;